module.exports = __webpack_public_path__ + "static/media/MANUAL_TÉCNICO_INSTALACIÓN_SUPERWALL.690514f6.pdf";